(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('outgoingAndWarehousing', {
                parent: 'module',
                url: '/outgoingAndWarehousing',
                params:{page: null},
                data: {
                    authorities: ['ROLE_OUTIN_WAREHOUSE']
                },
                views: {
                    'content': {
                        templateUrl: 'app/finishedWarehouse/outgoingAndWarehousing/outgoingAndWarehousing.html',
                        controller: 'OutgoingAndWarehousingController',
                        controllerAs: 'vm'
                    }
                }
            })
    }
})();
